import { createSelector, createSelectorMemoized } from '@base-ui/utils/store';
// Warning: Only add selectors here that do not belong to any specific feature.
export const schedulerOtherSelectors = {
  /**
   * Returns `true` if the event with the given ID is the currently active event.
   */
  isEditedEvent: createSelector(state => state.editedEventId, (editedEventId, eventId) => editedEventId === eventId),
  visibleDate: createSelectorMemoized(state => state.adapter, state => state.visibleDate, state => state.displayTimezone, (adapter, visibleDate, timezone) => adapter.setTimezone(visibleDate, timezone)),
  isScopeDialogOpen: createSelector(state => state.pendingUpdateRecurringEventParameters != null),
  /**
   * The default event color used when no color is specified on the event or its resource.
   */
  defaultEventColor: createSelector(state => state.eventColor),
  displayTimezone: createSelector(state => state.displayTimezone),
  plan: createSelector(state => state.plan),
  areRecurringEventsAvailable: createSelector(state => state.plan === 'premium'),
  isLoading: createSelector(state => state.isLoading),
  errors: createSelector(state => state.errors)
};